export default "data:image/png;base64,UklGRk4AAABXRUJQVlA4TEIAAAAvBsABEFcw//M//0baRs6dhLKngx/YAQBCCIdHYBrJVqThCASLIy4clgxwJHHsTsQR/Q9aonydreFo/jR8Tq6VsSI="